import Bill from '../../../base/bill/Bill.vue';
import Mode from '../../../base/bill/Mode.js';
import ModeHelper from '../../../base/bill/ModeHelper.js';

export default class DepartmentBill{

    modeHelper = null;
    menuId = null;
    modeLoaded = false;
    modeInfo = null;

    setMenuId(menuId){
        this.menuId = menuId;
        this.modeLoaded = false;
    }

    getMenuId(){
        return this.menuId;
    }

    async loadModeInfo(){
        console.log("loading 1");
        if(!this.menuId)
            throw new Error();
        if(this.modeInfo && this.modeLoaded)
            return this.modeInfo;
        else{
            if(!this.modeHelper)
                this.modeHelper = new ModeHelper(this);
            
            this.modeInfo =  await this.modeHelper.getBillSupportAction();
            return this.modeInfo;
        }
    }

    getModeInfo(){
        return this.modeInfo;
    }

    getModeHelper(){
        return this.modeHelper;
    }

}